import React, { useEffect, useRef, useState } from "react";
import topSvg from "../../assets/svg/top.svg";
import bottomSvg from "../../assets/svg/bottom.svg";
import mainLogoSvg from "../../assets/img/Main logo.png";
import svg41 from "../../assets/svg/svg41.svg";
import { Divider, Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { handleLoginSession, saveOtp } from "../../features/auth/authSlice";
import { fetchData } from "../../features/fetch/fetchSlice";

function LoginOtp() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);
 
  const { user,saving, authLoading, loginInfo } = useSelector((state) => state.auth);

  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const [isInputEmpty, setIsInputEmpty] = useState(true);

  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);

  const [counter, setCounter] = useState({ minutes: 0, seconds: 59 });

  const cancatenatedString = verificationCode?.join("");

  const onFinish = async (data) => {
    if (isInputEmpty) {
      toast.error("Please provide a valid OTP");
      return;
    }
    const res = await dispatch(
      saveOtp({
        usrId: loginInfo,
        usrSecret: cancatenatedString,
        url: "auth/validate-login-otp",
      })
    );
    if (res?.payload?.success) {
      await localStorage.setItem("token", res?.payload?.token);
      await dispatch(handleLoginSession());
      await toast.success(res.payload?.message);
      await setIsInputEmpty(true);
      await setVerificationCode(["", "", "", ""]);
      await form.resetFields(); 
      await navigate("/dashboard-main");
    } else {
      toast.error(res.payload?.message);
    }
  };



  const handleInputChange = (e, index) => {
    const { value } = e.target;
    setIsInputEmpty(!value);
    if (value === "") {
      if (index > 0) {
        inputRefs[index - 1].current.focus();
      }
    } else if (index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const updatedVerificationCode = [...verificationCode];
    updatedVerificationCode[index] = value;
    setVerificationCode(updatedVerificationCode);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (pastedData.length > 0) {
      const chars = pastedData.slice(0, 4).split("");
      const updatedVerificationCode = ["", "", "", ""];
      chars.forEach((char, index) => {
        updatedVerificationCode[index] = char;
      });
      setVerificationCode(updatedVerificationCode);
      setIsInputEmpty(chars.length === 0);
      const focusIndex = Math.min(chars.length, 3);
      inputRefs[focusIndex].current.focus();
    }
  };

  const handleCancel = async () => {
    await navigate("/login");
  };
  async function handleResendOtp() {
    const res = await dispatch(
      saveOtp({
        url: `auth/resend-otp/${loginInfo}`,
      })
    );
    if (res?.payload?.success) {
      setCounter({ minutes: 0, seconds: 59 });
      await toast.success(res.payload?.message);
    } else {
      toast.error(res.payload?.message);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter.minutes === 0 && counter.seconds === 0) {
        clearInterval(interval);
      } else {
        setCounter((prevCounter) => {
          if (prevCounter.seconds === 0) {
            return { minutes: prevCounter.minutes - 1, seconds: 59 };
          } else {
            return { ...prevCounter, seconds: prevCounter.seconds - 1 };
          }
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, authLoading]);

  return (
    <div className="w-full h-full min-h-screen flex flex-col op-bg">
      <div>
        <img src={topSvg} alt="topSvg" />
      </div>
      <div className="w-full flex flex-col h-full lg:px-0 px-3 lg:items-center lg:justify-center ">
        <div className="login-card lg:p-[2.5rem] p-3">
          <div>
            <img src={mainLogoSvg} alt="mainLogoSvg" />
          </div>
          <div className="typography_1 mt-[2.5rem]">
            Sign in to your account
          </div>
          <div className="typography_2">
            Welcome to State Department for Irrigation.
          </div>

          <div className="dash-card-h1 !text-[#1A1A1A] mt-[2.5rem] font-sora">
            Please enter code sent to your email and phone number
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="lg:w-[30.6875rem] w-full"
            form={form}
          >
            <div className="flex items-center justify-start gap-[1.25rem] mt-[1rem] w-full">
              {inputRefs?.map((ref, index) => (
                <div key={index}>
                  <input
                    ref={ref}
                    className="otp-input"
                    type="text"
                    maxLength="1"
                    value={verificationCode[index]}
                    onChange={(e) => handleInputChange(e, index)}
                    onPaste={handlePaste}
                  />
                </div>
              ))}
            </div>

            <div className="mt-[2rem] flex justify-start w-full">
              {counter.minutes === 0 && counter.seconds === 0 ? (
                <button
                  disabled={saving}
                  className="label_3 underline cursor-pointer"
                  onClick={handleResendOtp}
                  type="button"
                >
                  Resend code?
                </button>
              ) : (
                <span className="label_3 !text-blu">
                  Resend in {counter.minutes.toString().padStart(2, "0")}:
                  {counter.seconds.toString().padStart(2, "0")}
                </span>
              )}
            </div>

            <div className="justify-start flex items-start gap-x-2 my-[2rem]">
              <div className="w-[150px]">
                <button type="submit" className="cstm-btn-2">
               {saving ? <Spin/> : "Verify"}   
                </button>
              </div>
            </div>

            <div className="flex justify-end text-end">
              {/* <Link className="forgot-text">Forgot Password?</Link> */}
              <Link className="forgot-text !text-[#0092CC]">Help</Link>
            </div>

            <div className="mt-[2.5rem]">
              <Divider />
            </div>

            <div
              className="mt-[1.25rem] flex items-center gap-x-[1rem] cursor-pointer"
              onClick={handleCancel}
            >
              <img src={svg41} alt="svg41" />
              <span className="back">Back to login</span>
            </div>
          </Form>
        </div>
      </div>
      <div className="w-full  mt-auto flex items-center justify-center bottom-0">
        <img src={bottomSvg} alt="bottomSvg" />
      </div>
    </div>
  );
}

export default LoginOtp;
